import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../../store/actions'
import styles from './Crm.module.css'
import { useTranslation } from "react-i18next";
import CrmModule from './CrmModule';
import { getUserModules, patchUserModule } from '../../../../axios/requests/moduleReq'
import { useNavigate } from "react-router-dom";

import { DndContext, closestCenter, DragOverlay } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove } from "@dnd-kit/sortable";

const Crm = (props) => {
    const [moduleListState, setModuleListState] = useState([])
    const [selectionState, setSelectionState] = useState() 
    const crmState = useSelector(state => state.crm)
    const {selectedCrmModule,moduleSelectionMode} = crmState
    const [activeItem, setActiveItem] = useState(null); // Track the currently dragged item
    const [pendingModuleOrder, setPendingModuleOrder] = useState(null);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [t] = useTranslation('crm')

    const { divStyle_selectContactContainer } = props
    const crmModuleDragEnabled = selectionState === 'layout'


    useEffect(() => {
        if (pendingModuleOrder) {
            patchUserModule({ moduleOrder: pendingModuleOrder });
            setPendingModuleOrder(null); // Reset after patching
        }
    }, [pendingModuleOrder]); // Runs only when `pendingModuleOrder` changes


    useEffect(() => {
        const initModules = async () => {
            const modules = await getUserModules()
            setModuleListState(modules)
        }
        initModules()
    }, [])

    const handleDragStart = (event) => {
        if (!crmModuleDragEnabled) return;
        setActiveItem(moduleListState.find((item) => item._id === event.active.id));
    };

    const handleDragEnd = (event) => {
        if (!crmModuleDragEnabled) return;

        const { active, over } = event;
        if (!over || active.id === over.id) return; // Prevent invalid drag actions

        setActiveItem(null);

        setModuleListState((moduleList) => {
            const updatedList = [...moduleList]; // Clone array

            const oldIndex = updatedList.findIndex((item) => item._id === active.id);
            const newIndex = updatedList.findIndex((item) => item._id === over.id);
            if (oldIndex === -1 || newIndex === -1) return moduleList; // Prevent invalid cases

            // Swap order values based on actual item order, not array index
            [updatedList[oldIndex].order, updatedList[newIndex].order] =
                [updatedList[newIndex].order, updatedList[oldIndex].order];

            // Ensure the list is correctly sorted by order before updating API
            const sortedList = updatedList.sort((a, b) => a.order - b.order);

            // Prepare module order for API
            const moduleOrder = sortedList.map((module, index) => ({
                moduleId: module._id,
                order: index + 1 // Assign a correct sequential order
            }));

            setPendingModuleOrder(moduleOrder); // Queue for API update

            return sortedList;
        });
    };

    const onSelectManageModuleHandler = (crmModuleObj, selectionMode) => {
        if (selectionState === 'select' && crmModuleObj?._id === selectedCrmModule?._id) {
            dispatch(actions.setCrmModule(), undefined)
            setSelectionState()// Reset selected obj
        }
        else {
            dispatch(actions.setCrmModule(crmModuleObj, selectionMode))
        }
    }

    const onNewSelectionClickHandler = (newSelection) => {
        if (selectionState === newSelection) {
            setSelectionState()
            if (newSelection === 'select') {
                onSelectManageModuleHandler()// Reset selected obj
            }
        }
        else {
            setSelectionState(newSelection)
        }
    }

    const onCrmModuleClickHandler = (crmModuleObj) => {
        if (selectionState === 'select') {
            onSelectManageModuleHandler(crmModuleObj,'select')
        }
        else if (selectionState === 'layout') {
            //Do nothing
        }
        else {//Open Modal
            onSelectManageModuleHandler(crmModuleObj,'show-records')
            navigate(`/crm/${crmModuleObj?.name}/records/`)

        }
    }

    let multipleSelectionBtnDiv = []
    if (props.selectMultipleBtnClicked) {
        multipleSelectionBtnDiv = [styles.multipleSelectionBtnDiv, styles.selectMultipleBtnClicked].join(' ')
    }

    let CrmModulesArr
    if (moduleListState?.length) {
        CrmModulesArr = moduleListState.map(module => {
            return <CrmModule id={module._id} title={module.label} disabled={!crmModuleDragEnabled} selectedModule={selectedCrmModule} moduleSelectionMode={moduleSelectionMode} onClick={() => onCrmModuleClickHandler(module)} />
        })
    }

    return (
        <div className={divStyle_selectContactContainer}>

            <DndContext collisionDetection={closestCenter} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                <SortableContext items={moduleListState} strategy={verticalListSortingStrategy}>
                    <div className='col-12 contacts-container costContactsCol'>
                        <div className='col-12 multipleSelectionBtnsDiv'>
                            <div className={styles.multipleSelectionDiv}>
                                <div className={`${styles.multipleSelectionBtnDiv} ${selectionState === 'layout' && styles.selectMultipleBtnClicked}`} onClick={() => onNewSelectionClickHandler('layout')}>
                                    <span className={styles.toSelectBtn}>{t('Layout')}</span>
                                </div>
                                <span className={styles.devider}>|</span>
                                <div className={`${styles.multipleSelectionBtnDiv} ${selectionState === 'select' && styles.selectMultipleBtnClicked}`} onClick={() => onNewSelectionClickHandler('select')}>
                                    <span className={styles.toSelectBtn}>{t('Selection')}</span>
                                </div>
                            </div >
                        </div>
                        {CrmModulesArr}
                    </div>
                </SortableContext>
                {/* 🔥 Drag Overlay: Shows the dragged element on top */}
                <DragOverlay>
                    {activeItem ? (
                        <CrmModule
                            id={activeItem._id}
                            title={activeItem.label}
                            style={{ transform: "translate(-90%, -40%)", pointerEvents: "none" }}
                        />
                    ) : null}
                </DragOverlay>

            </DndContext>
        </div>
    )
}

export default Crm